import React from 'react';

/**
 * Temporary Sentry verification button — development only.
 * Click to throw: "This is your first error!" and confirm it appears in Sentry.
 */
const SentryErrorButton: React.FC = () => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => {
        throw new Error('This is your first error!');
      }}
      className="fixed bottom-24 right-4 z-[60] min-h-11 rounded-xl bg-red-600 px-4 py-2.5 text-sm font-bold text-white shadow-lg hover:bg-red-700"
      aria-label="Sentry test error"
    >
      Break the world
    </button>
  );
};

export default SentryErrorButton;
